/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_PeriodInputs */

const en_admin_subscriptions_period = /** @type {(inputs: Admin_Subscriptions_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Period`)
};

const zh_admin_subscriptions_period = /** @type {(inputs: Admin_Subscriptions_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前周期`)
};

/**
* | output |
* | --- |
* | "Period" |
*
* @param {Admin_Subscriptions_PeriodInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_period = /** @type {((inputs?: Admin_Subscriptions_PeriodInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_PeriodInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_subscriptions_period(inputs)
	return zh_admin_subscriptions_period(inputs)
});
export { admin_subscriptions_period as "admin.subscriptions.period" }